module.exports = __webpack_public_path__ + "media/images/metronic/syncfusion-icons-ae89a01220681a44d234883b7496c85e.png";